export const getActiveServices = (services) => services.filter((service) => !service.disabled);

export const getServicesId = (services) => {
  const activeServices = getActiveServices(services);
  return activeServices.map((service) => service.id);
};

export const getServicesChecked = (services, checked) => {
  if (checked?.length) {
    return services.filter((service) => checked.includes(service.id));
  }
  return [];
};

export const getServicesSearch = (services, search) => {
  if (search && !!search.trim() && services) {
    return services.filter((service) => (service.id + service.name).trim().toLowerCase().indexOf(search.trim().toLowerCase()) !== -1);
  }
  return services;
};

export const sortByRateAsc = (a, b) => {
  const rateA = a.rate ? parseFloat(a.rate) : false;
  const rateB = b.rate ? parseFloat(b.rate) : false;

  if (rateA && rateB) {
    if (rateA < rateB) {
      return -1;
    }
    if (rateA > rateB) {
      return 1;
    }
    if (rateA === rateB) {
      return `${a.name}`.localeCompare(b.name);
    }
  }
  return 0;
};

export const sortByRateDesc = (a, b) => {
  const rateA = a.rate ? parseFloat(a.rate) : false;
  const rateB = b.rate ? parseFloat(b.rate) : false;

  if (rateA && rateB) {
    if (rateA < rateB) {
      return 1;
    }
    if (rateA > rateB) {
      return -1;
    }
  }
  return 0;
};

export const getSelectedList = (list, checked, provider) => list.reduce((filtered, category) => {
  const checkedServices = getServicesChecked(category.services, checked);

  if (checkedServices.length) {
    filtered.push({
      ...category,
      collapsed: false,
      showEdit: false,
      services: checkedServices.map((service) => {
        const prepareRefillCancel = {};
        if (provider.type === 1) {
          if (service.refill) prepareRefillCancel.refill = true;
          if (service.cancel) prepareRefillCancel.cancel = true;
        }
        if (provider.type === 0) {
          if (provider.refill) prepareRefillCancel.refill = false;
          if (provider.cancel) prepareRefillCancel.cancel = false;
        }

        const newService = {
          ...service,
          dripfeed: false,
          ...prepareRefillCancel,
          formData: {
            name: service.name,
            description: service.description,
            ...prepareRefillCancel,
            dripfeed: false,
            name_translations: service?.name_translations,
            description_translations: service?.description_translations,
          },
          rateCopy: service.rate,
        };
        delete newService?.name_translations;
        delete newService?.description_translations;

        return newService;
      }),
    });
  }
  return filtered;
}, []);

export const getListAfterFilter = (list, checked = [], search, hideAdded, sort) => {
  if (list) {
    const reducedList = list.reduce((filtered, category) => {
      const activeServices = getActiveServices(category.services);
      const checkedServices = getServicesChecked(category.services, checked);
      const servicesActiveLength = activeServices.length;
      const isDisabledSelectALL = servicesActiveLength === 0;
      const isCheckedSelectAll = servicesActiveLength === checkedServices.length;
      const servicesSearch = getServicesSearch(category.services, search);

      if (servicesSearch.length) {
        filtered.push({
          ...category,
          checked: isCheckedSelectAll && !isDisabledSelectALL,
          disabled: isDisabledSelectALL,
          services: servicesSearch.map((service) => ({
            ...service,
            showInfo: service.showInfo,
            showEdit: service.showEdit,
            checked: checked.includes(service.id),
          })),
        });
      }
      return filtered;
    }, []);

    if (sort === 'asc') {
      return reducedList.map((category) => ({
        ...category,
        services: category.services.sort(sortByRateAsc),
      }));
    }
    if (sort === 'desc') {
      return reducedList.map((category) => ({
        ...category,
        services: category.services.sort(sortByRateDesc),
      }));
    }

    if (hideAdded) {
      return reducedList
        .filter((category) => !category.disabled)
        .map((category) => ({
          ...category,
          services: category.services.filter((item) => !item.disabled),
        }))
        .filter((category) => category?.services?.length);
    }

    return reducedList;
  }
  return list;
};

export const sortByRate = (sortType, state) => {
  if (sortType === 'asc') {
    return state.list.map((category) => ({
      ...category,
      services: category.services.sort(sortByRateAsc),
    }));
  }
  if (sortType === 'desc') {
    return state.list.map((category) => ({
      ...category,
      services: category.services.sort(sortByRateDesc),
    }));
  }
  if (sortType === 'all') {
    const allUncollapsedList = state?.listDefault?.map((item) => ({ ...item, collapsed: false }));
    return getListAfterFilter(
      state.search.trim() ? allUncollapsedList : state.listDefault,
      state.checked,
      state.search,
      state.search.trim() ? false : state.hideAdded,
    );
  }
};

export const getHeightRow = (row, categoryHeight) => {
  if (row.collection === 'category') {
    return categoryHeight;
  }
  const rows = Math.ceil(row.name.length / 48);
  const basicHeight = 58;
  const step = rows === 1 ? 0 : 10;
  return rows * step + basicHeight;
};
